import { action } from 'satcheljs';
import type { MailboxInfo } from 'owa-client-types';

export default action('onAccountGoodState', (mailboxInfo: MailboxInfo) => ({
    mailboxInfo,
}));
